/* ------------------------------------------- */
/*   Actions for GET / POST CRQ from/to API
/* ------------------------------------------- */

import {
  postCrq,
  getCrq,
} from 'AppSrc/core/crq/crq-queries';


/* --- Actions Types --- */

// Create (POST) CRQ to API
const CREATE_UPDATE_CRQ_REQUEST = 'CREATE_UPDATE_CRQ_REQUEST';
const CREATE_UPDATE_CRQ_SUCCESS = 'CREATE_UPDATE_CRQ_SUCCESS';
const CREATE_UPDATE_CRQ_ERROR = 'CREATE_UPDATE_CRQ_ERROR';
// Fetch (GET) CRQ from API
const FETCH_CRQ_REQUEST = 'FETCH_CRQ_REQUEST';
const FETCH_CRQ_SUCCESS = 'FETCH_CRQ_SUCCESS';
const FETCH_CRQ_ERROR = 'FETCH_CRQ_ERROR';


/* ------ ACTION CREATORS ------ */

/* - create CRQ synchronous actions - */

const createUpdateCrqRequest = (crqData) => ({
  type: CREATE_UPDATE_CRQ_REQUEST,
  payload: {
    crqData,
  },
});

const createUpdateCrqSuccess = (crqId, crqData) => ({
  type: CREATE_UPDATE_CRQ_SUCCESS,
  payload: {
    crqId,
    crqData,
  },
});

const createUpdateCrqError = (crqData, error) => ({
  type: CREATE_UPDATE_CRQ_ERROR,
  payload: {
    crqData,
    error,
  },
});


/* - fetch CRQ synchronous actions - */

const fetchCrqRequest = (network, crqId) => ({
  type: FETCH_CRQ_REQUEST,
  payload: {
    network,
    crqId,
  },
});

const fetchCrqSuccess = (network, crqId, crqData) => ({
  type: FETCH_CRQ_SUCCESS,
  payload: {
    network,
    crqId,
    crqData,
  },
});

const fetchCrqError = (network, crqId, error) => ({
  type: FETCH_CRQ_ERROR,
  payload: {
    network,
    crqId,
    error,
  },
});


/* - Create CRQ thunk action  - */
const createUpdateCrq = (params) => (dispatch, getState) => {

  const {
    crqData,
    crqId = null,
  } = params;

  // notify reducer saving has started
  dispatch(createUpdateCrqRequest(crqData));

  // REST POST request
  return postCrq(crqData, crqId)
    .then((data) => {
      // endpoint returns e.g {id: 1, network: mobile}
      const { id } = data;
      dispatch(createUpdateCrqSuccess(id, crqData));
      return id;
    })
    .catch((error) => {
      dispatch(createUpdateCrqError(crqData, error));
      // bubble promise up to the next catch
      return Promise.reject(error);
    });
};


/* - Fetch CRQ thunk action  - */
const fetchCrq = (network, crqId) => (dispatch, getState) => {

  // notify reducer fetching has started
  dispatch(fetchCrqRequest(network, crqId));

  // REST GET request
  return getCrq(network, crqId)
    .then((crqData) => {
      dispatch(fetchCrqSuccess(network, crqId, crqData));
    })
    .catch((error) => {
      dispatch(fetchCrqError(network, crqId, error));
    });
};


export {
  CREATE_UPDATE_CRQ_REQUEST,
  CREATE_UPDATE_CRQ_SUCCESS,
  CREATE_UPDATE_CRQ_ERROR,
  createUpdateCrqRequest,
  createUpdateCrqSuccess,
  createUpdateCrqError,
  createUpdateCrq,
  FETCH_CRQ_REQUEST,
  FETCH_CRQ_SUCCESS,
  FETCH_CRQ_ERROR,
  fetchCrqRequest,
  fetchCrqSuccess,
  fetchCrqError,
  fetchCrq,
};
